import React, { useEffect, useState } from 'react'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import moment from 'moment'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_BUQUES } from '../../../../config/forms'
import EventBusyIcon from '@material-ui/icons/EventBusy'
import { resetDetalleCarga, actualizacionAnuncioCarga } from '../../actions/TablaCargaBuquesActions'
import CargaDeBuque from './CargaDeBuque'
import EventIcon from '@material-ui/icons/Event'
import { COLORES } from '../../../../config/colores'

function FechasCargaBuque (props) {
  const { data = null, change: formChange, actualizacionAnuncioCarga, actualizarEstimacion = null } = props
  const [open, setOpen] = useState(false)
  const [fechaDesde, setFechaDesde] = useState(null)
  const [fechaHasta, setFechaHasta] = useState(null)

  useEffect(() => {
    if (data && data.fechaDeCargaDesde) {
      setFechaDesde(data.fechaDeCargaDesde)
      setFechaHasta(data.fechaDeCargaHasta)
    }
  }, [data])

  const handleOpen = () => {
    setOpen(true)
    actualizacionAnuncioCarga(false)
  }

  const handleClose = () => {
    setOpen(false)
    formChange('fechaInicioCarga', null)
    formChange('fechaFinCarga', null)
    props.resetDetalleCarga()
    if (actualizarEstimacion) { actualizarEstimacion() }
  }

  const fechas = (!fechaDesde && !fechaHasta)
    ? <EventBusyIcon style={{ color: '#938d95' }} />
    : <>
      <EventIcon style={{ color: COLORES.violet }} />
      { (fechaDesde === fechaHasta)
        ? `${moment(fechaDesde).format('DD/MM/YYYY')} `
        : `${moment(fechaDesde).format('DD/MM')} al ${moment(fechaHasta).format('DD/MM')}`
      }
    </>

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Actualizar detalle de carga'
          content={<CargaDeBuque data={data} />}
        />
      </Dialog>
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Tooltip title={(!fechaDesde && !fechaHasta) ? 'Agregar detalle de carga' : 'Editar detalle de carga'}>
          <IconButton onClick={handleOpen} style={{ outline: 'none', padding: 0 }}>
            <div style={{ fontSize: '0.8rem' }}>{fechas}</div>
          </IconButton>
        </Tooltip>
      </div>

    </>
  )
}

const selector = formValueSelector(FORM_BUQUES)
const mapStateToProps = (state) => ({
  fechaInicio: selector(state, 'fechaInicioCarga'),
  fechaFin: selector(state, 'fechaFinCarga')
})

const mapActionsToProps = {
  actualizacionAnuncioCarga,
  resetDetalleCarga
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_BUQUES
})

export default withRedux(withReduxForm(FechasCargaBuque))
